import { render, staticRenderFns } from "./report_personal.vue?vue&type=template&id=64afed6e&scoped=true"
import script from "./report_personal.vue?vue&type=script&lang=js"
export * from "./report_personal.vue?vue&type=script&lang=js"
import style0 from "./report_personal.vue?vue&type=style&index=0&id=64afed6e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64afed6e",
  null
  
)

export default component.exports